export default "__VITE_ASSET__DmfRA7rA__"